import styled, { css } from 'styled-components'
import { breakpoint } from '@sketch/global-styles'
import { ButtonUnstyled } from '@sketch/components'

import BaseGridPublicationItem from '../GridPublicationItem'

export const GridPublicationItem = styled(BaseGridPublicationItem)`
  min-width: 252px;
  flex: 1;

  & + & {
    margin-left: 40px;
  }
`

export const SliderWrapper = styled.div`
  display: flex;
  position: relative;

  margin: 0 -40px;
  padding-bottom: 10px; /* stylelint-disable-line scales/space */

  ${breakpoint('base', 'sm')`
    margin: 0 -24px;
  `};

  ::after,
  ::before {
    ${breakpoint('base', 'sm')`
      width: 24px;
    `}

    width: 40px;

    content: '';
    display: block;
    flex-shrink: 0;
  }
`

export const ScrollbarWrapper = styled.div`
  ${breakpoint('base', 'sm')`
    margin: 0 -24px;
    padding: 32px 24px 30px;  
  `};

  margin: 0 -40px;
  padding: 32px 40px 10px; /* stylelint-disable-line scales/space */
  -webkit-overflow-scrolling: touch;

  overflow-x: auto;

  /* We hide the browser scrollbars because we have a fake one */
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const ScrollbarTrack = styled(ButtonUnstyled)<{ $pressed: boolean }>`
  display: block;
  position: sticky;
  left: 0;
  top: 0;

  height: 20px;
  padding: 5px 0; /* stylelint-disable-line scales/space */

  background-color: ${({ theme }) => theme.colors.background.tertiary.A};
  background-clip: content-box;

  /* clip-path was used to fake the rounded corners because of padding, so the hit area is bigger */
  clip-path: inset(5px 0px 5px 0px round 10px);
  cursor: default;

  :hover {
    background-color: ${({ theme }) => theme.colors.background.primary.C};
  }

  ${({ $pressed }) =>
    $pressed &&
    css`
      background-color: ${({ theme }) => theme.colors.background.primary.C};
    `}
`
